module.exports = __webpack_public_path__ + "img/inventory.60e8b4b6.svg";